import api from './config';

export interface UserActivity {
  id: number;
  user_id: string;
  user_email: string | null;
  action: string;
  entity_type: string;
  entity_id: string;
  details: string | null;
  created_at: string;
}

export interface ActivityPagination {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
}

export interface ActivityStatsSummary {
  total_activities: number;
  unique_users: number;
  total_logins: number;
  total_page_views: number;
}

export interface ActivityStats {
  summary: ActivityStatsSummary;
  actionStats: { action: string; count: number }[];
  entityStats: { entity_type: string; count: number }[];
  userStats: { user_id: string; user_email: string; activity_count: number }[];
  dailyActivity: { date: string; count: number }[];
  dailyLogins: { date: string; count: number }[];
  topPages: { page_path: string; count: number }[];
}

export interface NavigationEntry {
  id: number;
  userId: string;
  userEmail: string;
  pagePath: string;
  pageTitle: string;
  referrer: string;
  timestamp: string;
}

export interface ActivityQueryParams {
  page?: number;
  limit?: number;
  userId?: string;
  action?: string;
  entityType?: string;
  entityId?: string;
  startDate?: string;
  endDate?: string;
  excludeActions?: string;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export const activityService = {
  async getActivities(params: ActivityQueryParams = {}): Promise<{
    activities: UserActivity[];
    pagination: ActivityPagination;
  }> {
    const response = await api.get('/activities', { params });
    return response.data;
  },

  async getStats(params: {
    startDate?: string;
    endDate?: string;
    userId?: string;
    excludeActions?: string;
  } = {}): Promise<ActivityStats> {
    const response = await api.get('/activities/stats', { params });
    return response.data;
  },

  async getNavigationHistory(params: { userId?: string; limit?: number } = {}): Promise<{
    navigationHistory: NavigationEntry[];
  }> {
    const response = await api.get('/activities/navigation-history', { params });
    return response.data;
  },

  async logNavigation(pagePath: string, pageTitle?: string, referrer?: string): Promise<void> {
    await api.post('/activities/log-navigation', { pagePath, pageTitle, referrer });
  },
};
